module.exports = __webpack_public_path__ + "img/productHSE_8.77a5f4f0.png";